.pill {
  position: absolute;
  right: 16px;
  bottom: calc(100% + 8px);
  display: flex;
  justify-content: flex-end;
  transition:
    opacity 200ms ease,
    transform 200ms ease;
}

.pill--hidden {
  opacity: 0;
  transform: translateY(4px);
  pointer-events: none;
  visibility: hidden;
  transition:
    opacity 200ms ease,
    transform 200ms ease,
    visibility 0s linear 200ms;
}
